const toId = require("to-id");
import { nanoid } from "nanoid/non-secure";
const _ = require("lodash");
import { haversineDistance } from "@/models/Geolocation";
import { Geolocatable } from "@/models/Geolocation";

class Shop {
  _id: string;
  _rev: string | null;
  name: string;
  isPreferred: boolean;
  position: Geolocatable;

  constructor(data: any) {
    this.name = data.name;
    this.isPreferred = data.isPreferred || false;
    this.position = data.position;
    this._id = data._id || `Shop:${toId(this.name)}-${nanoid()}`;
    this._rev = data._rev || null;
  }

  static matchByPosition(shops: Array<Shop>, position: Geolocatable): Shop {
    const sortedByPreferenceAndDistance = _.sortBy(
      shops,
      (shop: Shop) => (shop.isPreferred ? 0 : 1),
      (shop: Shop) => {
        return haversineDistance(position, shop.position);
      }
    );

    const nearEnough = sortedByPreferenceAndDistance.filter((shop: Shop) => {
      return haversineDistance(position, shop.position) <= 50;
    });

    if (nearEnough.length === 0) {
      return null;
    }
    return nearEnough[0];
  }
}
export { Shop };
